import { _localesAllowed, Say } from "../../../../arc/locale/consts.js";
import { normalizeLocale } from "../../../../arc/locale/tools.js";

export const localeOptions = Object.freeze(_localesAllowed.map(value=>({ value })));

export const createLocaleValues = locale=>({
    value:normalizeLocale(locale) || _localesAllowed[0] || ""
});

export const createLocalePayload = (values, isPermanent)=>({
    isPermanent,
    value:values.value
});

export const getLocaleErrorId = error=>{
    const code = error?.code || "invalid";
    return Say.id("locale", "form", "validation", code);
};

const hasErrors = validation=>{
    if (!validation) { return false; }
    return !!Object.keys(validation.fieldErrors || {}).length || !!validation.formErrors?.length;
};

export const getLocaleFieldError = validation=>{
    return validation?.fieldErrors?.value || validation?.formErrors?.find(error=>{
        return error.fields?.includes("value");
    });
};

export const mergeLocaleValidation = (localValidation, serverValidation)=>{
    if (!serverValidation) { return localValidation; }
    return {
        ...localValidation,
        fieldErrors:{ ...localValidation.fieldErrors, ...serverValidation.fieldErrors },
        formErrors:[...localValidation.formErrors, ...serverValidation.formErrors],
        isValid:false
    };
};

export const validationFromReply = reply=>{
    const detail = reply?.error?.detail || reply?.details;
    const validation = {
        fieldErrors:detail?.fieldErrors || {},
        formErrors:Array.isArray(detail?.formErrors) ? detail.formErrors : []
    };
    return hasErrors(validation) ? validation : null;
};
